// A line at the bottom of the screen that says what just happened, and goes.

let el: HTMLDivElement | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;

export function toast(text: string): void {
  if (!el) {
    el = document.createElement("div");
    el.className = "toast";
    el.setAttribute("role", "status");
    document.body.append(el);
  }
  el.textContent = text;
  el.classList.add("show");
  clearTimeout(timer);
  timer = setTimeout(() => el?.classList.remove("show"), 2200);
}
